import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { AbstractControl, FormBuilder, FormGroup, Validators } from '@angular/forms';
import { DatePipe } from '@angular/common';
import { HttpErrorResponse } from '@angular/common/http';
import { MatDialog } from '@angular/material/dialog';
import { Router } from '@angular/router';
import { NgxSpinnerService } from 'ngx-spinner';
import { ToastrService } from 'ngx-toastr';
import { HttpService } from 'src/app/services/http.service';
import { ensureActiveSubscription } from 'src/app/shared/subscription-dialog';
import { URLUtils } from 'src/app/urlUtils';
import { environment } from 'src/environments/environment';
import { GeneralleavepageComponent } from '../generalleavepage/generalleavepage.component';
import { ConfirmationDialogService } from './../../../../confirmation-dialog/confirmation-dialog.service';
import { MatterService } from './../../../matter.service';
import { HostListener } from '@angular/core';

@Component({
    selector: 'general-matter-info',
    templateUrl: 'general-matter-info.component.html',
    styleUrls: ['general-matter-info.component.scss'],
    standalone: false
})
export class GeneralMatterInfoComponent implements OnInit {
  @Input() type: string = 'create';
  @Input() data: any;
  @Output() childButtonEvent = new EventEmitter();
  @Input() matterId: any;
  events: string[] = [];
  advicates: any
  generalForm: any = FormGroup;
  desc: any; 
  
  tags: any = [];
  //memberDetail:any=FormGroup;
  submitted = false;
  opponent_advocates: any = [];
  pipe = new DatePipe('en-US');
  isEdit: boolean = false;
  selectedPriority: string = "High";
  selectedStatus: string = "Active";
  editeMatterInfo: any;
  minDateEnd: any = new Date();
  Documents: any;
  isAddDisable: boolean = false;
  matterid:any;
  readonly NoWhitespaceRegExp: RegExp = new RegExp("\\S");
  showMore: boolean = false;
  getMatterId: any;
  product = environment.product;
  datePickerConfig = {
    dateInputFormat: 'MMM DD, YYYY',
    showWeekNumbers: false,
    showClearButton: true
  };
  createdatePickerConfig = {
    dateInputFormat: 'MMM DD, YYYY',
    showWeekNumbers: false,
    showClearButton: true,
    maxDate: new Date()
  };
  saveLate =false;

  @HostListener('window:beforeunload', ['$event'])
  handleBeforeUnload(event: BeforeUnloadEvent) {
    if (this.generalForm?.dirty || this.generalForm?.touched) {
      event.preventDefault();
      event.returnValue = ''; // to show warning
    }
  }

  constructor(private fb: FormBuilder, private oa: FormBuilder, private matterService: MatterService,private toast: ToastrService,private datePipe: DatePipe,
    private httpService: HttpService, private dialog: MatDialog, private spinnerService: NgxSpinnerService, private router: Router, private confirmationDialogService: ConfirmationDialogService) { }

  ngOnInit() {
    this.generalForm = this.fb.group({
      title: ['',[Validators.required,Validators.pattern(this.NoWhitespaceRegExp)]],
      matterNumber: ['',[ Validators.required,Validators.pattern(this.NoWhitespaceRegExp)]],
      startdate: [new Date()],
      closedate: [null],
      created_date:  [new Date()],
      description: [''],
      matterType: [''],
      status: ['Active'],
      priority: ['High'], 
      tags: ['']
    });


    if (!this.data) {
      if (window.location.pathname.indexOf("create") > -1) {
        this.getMatterID();
      }
    }

    if (this.data) {
      this.generalForm.patchValue(this.data);
      if (this.data?.startdate && this.data.startdate != "") {
        this.generalForm.controls["startdate"].setValue(new Date(this.data.startdate));
        this.minDateEnd = new Date(this.data.startdate)
      }
      if (this.data?.closedate && this.data.closedate != ""){
        this.generalForm.controls["closedate"].setValue(new Date(this.data.closedate));
      }
      if (this.data.status) {
        this.generalForm.controls["status"].setValue((this.data.status));
      }
      if (this.data.priority) {
        this.generalForm.controls["priority"].setValue((this.data.priority));
      }
      this.selectedStatus = this.data.status;
      this.selectedPriority = this.data.priority;
    }
    
    // Subscribe to form value changes
     this.generalForm.valueChanges.subscribe(() => {
      this.isAddDisable = this.checkIfFormHasValue();
     });
     if (window.location.pathname.indexOf("edit") > -1) {
      this.showMore=true;
      //console.log('tt showMore',this.showMore)

      this.matterService.editGeneralMatterObservable.subscribe((result: any) => {
        if (result) {
          this.applyMatterToForm(result);
          this.editeMatterInfo = result;
          this.matterid = result.id;
          //console.log('editeMatterInfo',this.editeMatterInfo)
          this.isEdit = true;
          this.generalForm.patchValue(this.editeMatterInfo);
          if (this.editeMatterInfo?.startdate && this.editeMatterInfo.startdate != "") {
            this.generalForm.controls["startdate"].setValue(new Date(this.editeMatterInfo.startdate));
            this.minDateEnd = new Date(this.editeMatterInfo.startdate)
          }
          if (this.editeMatterInfo.created_date) {
            this.generalForm.controls["created_date"].setValue(new Date(this.editeMatterInfo.created_date));
          }
    
          this.generalForm.controls["matterNumber"].setValue(this.editeMatterInfo.matter_id);

          if (this.editeMatterInfo?.closedate && this.editeMatterInfo.closedate != "")
            this.generalForm.controls["closedate"].setValue(new Date(this.editeMatterInfo.closedate));
          this.selectedStatus = this.editeMatterInfo.status;
          this.selectedPriority = this.editeMatterInfo.priority;
          
          if (this.editeMatterInfo?.tags) {
            this.tags = [...Object.values(this.editeMatterInfo.tags)];
          }
          //console.log("matter-info of tags: ", this.tags)
          //console.log(this.generalForm)
          this.getDocuments();
        }
      })
            
      const cached = localStorage.getItem('editMatterCache');
      if (cached) {
        const parsed = JSON.parse(cached);
        //console.log('Restored from localStorage', parsed);
        this.applyMatterToForm(parsed);
      }

    }
  }

  applyMatterToForm(data: any) {
    this.editeMatterInfo = data;
    this.matterid = data.id;
    //console.log('editeMatterInfo',this.editeMatterInfo)
    this.isEdit = true;
    this.generalForm.patchValue(this.editeMatterInfo);
    if (data.created_date) {
      this.generalForm.controls["created_date"].setValue(
        new Date(data.created_date)
      );
    }


    // if (this.editeMatterInfo.created_date) {
    //        this.generalForm.controls["created_date"].setValue(new Date(this.editeMatterInfo.created_date));
    // }
    
    if (this.editeMatterInfo?.startdate && this.editeMatterInfo.startdate != "") {
      this.generalForm.controls["startdate"].setValue(new Date(this.editeMatterInfo.startdate));
      this.minDateEnd = new Date(this.editeMatterInfo.startdate)
    }
    this.generalForm.controls["matterNumber"].setValue(this.editeMatterInfo.matter_id);

    if (this.editeMatterInfo?.closedate && this.editeMatterInfo.closedate != "")
      this.generalForm.controls["closedate"].setValue(new Date(this.editeMatterInfo.closedate));
    this.selectedStatus = this.editeMatterInfo.status;
    this.selectedPriority = this.editeMatterInfo.priority;

    if (this.editeMatterInfo?.tags) {
      this.tags = [...Object.values(this.editeMatterInfo.tags)];
    }
    //console.log("matter-info of tags: ", this.tags)
    //console.log(this.generalForm)
    this.getDocuments();
    this.getMatterID();
  }

  getMatterID() {
    this.spinnerService.show();
    this.httpService.sendGetRequest(URLUtils.getMatterId).subscribe((res: any) => {
      this.spinnerService.hide();
      //console.log("MatterId response:", res);
      if (res && res.matter_id) {
        this.generalForm.get('matterNumber')?.setValue(res.matter_id);
      }
    }); // get matter id as prefilled value
  }

  checkIfFormHasValue(): boolean {
    const controls = Object.values(this.generalForm.controls) as AbstractControl[];
    return controls.some(control => {
        return control.value && control.value.trim().length > 0;
    });
  }

  get f() {
    return this.generalForm.controls;
  }
  // get member_name(){
  //   return this.generalForm.memberDetail.get('member_name') as FormControl;
  // }
  receiveAutoMsgHandler(details: any) {
    this.advicates = details;
    //console.log(" this.advicates------------>" + this.advicates)
  }
receiveTagMsgHandler(details: any) {
    if (details == null) {
      this.isAddDisable = true;
    } else {
      this.isAddDisable= true;
      this.tags = details;
    }
    // console.log(" details: ", details)
    // console.log(" this.tags------------>" + this.tags)
  } 
  getPriority(data: any) {
    this.generalForm.controls.priority.patchValue(data ? data : "High");

  }
  getStatus(data: any) {
    this.generalForm.controls.status.patchValue(data ? data : "Active");
  }
  addOpponenteAdvicate() {

  }
    
  // convertTagsToObject(tagsArray: any[]): { [key: string]: string } {
  //   const tagObject: { [key: string]: string } = {};
  //   tagsArray.forEach((tag, index) => {
  //     tagObject[index] = tag.name;
  //   });
  //   return tagObject;
  // }
  convertTagsToObject(tagsArray: any[]): { [key: string]: string } {
    const tagObject: { [key: string]: string } = {};
    tagsArray.forEach((tag, index) => {
      // If tag is an object with a name property, use it; otherwise, assume it's a string
      tagObject[index] = typeof tag === 'string' ? tag : tag.name || '';
    });
    return tagObject;
  }

  onSubmit() {
    if (!ensureActiveSubscription(this.confirmationDialogService)) { return; }
    this.submitted = true;
    if (this.generalForm.invalid) {
      return;
    }
    let matter = this.generalForm.value
    // let body = {"title":matter.title, "matter_number": matter.matterNumber, "type": "general"} 
    // let editbody = {"title":matter.title, "matter_number": matter.matterNumber, "matter_id": this.matterid, "type": "general"} 
    let body = {"title":matter.title, "type": "general"} 
    let editbody = {"title":matter.title, "type": "general", "matter_id": this.matterId || this.editeMatterInfo?.id} 
    // console.log('this.generalForm.value',this.generalForm.value)

    // const tagObject: { [key: number]: string } = {};
    // this.tags.forEach((tag: { name: string }, index: number) => {
    // tagObject[index] = tag.name;
    // });
    // this.generalForm.value.tags = tagObject;
            
    if (!Array.isArray(this.tags)) {
      this.tags = [];
    }
    this.generalForm.value.tags = [...this.tags]; // adding tags

    // if(!this.isEdit){
    // this.generalForm.value.startdate = this.pipe.transform(this.generalForm.value.startdate, 'dd-MM-yyyy');
    // this.generalForm.value.closedate = this.pipe.transform(this.generalForm.value.closedate, 'dd-MM-yyyy');
    // }
    //this.generalForm.value.status = this.generalForm.status == "INVALID" || this.generalForm.status == "VALID" ? "Active" : this.generalForm.status;
    // this.generalForm.value.priority = this.generalForm?.priority ? this.generalForm.priority : "High";

    if (!this.editeMatterInfo) {
      this.httpService.sendPostRequest(URLUtils.checkMatterUnique, body).subscribe((res: any) => {
        if (res.error) {
          this.toast.error(res.msg);
          return;
          // this.confirmationDialogService.confirm('Alert', res.msg, false, 'OK', 'Cancel', true)
          //   .then((confirmed) => {
          //     if (confirmed) {
          //     }
          //   })
          // return;
        }
        else {
          // add type also in this .generalForm.value as 
          this.childButtonEvent.emit(this.generalForm.value);
        }
      })
      //this.childButtonEvent.emit(this.generalForm.value);
    }
    else if (window.location.pathname.indexOf("edit") > -1) {
      let data = {
        "title": this.generalForm.value.title,
        "matter_number": this.generalForm.value.matter_id,
        "startdate": this.pipe.transform(this.generalForm.value.startdate, 'dd-MM-yyyy'),
        "closedate": this.pipe.transform(this.generalForm.value.closedate, 'dd-MM-yyyy'),
        "description": this.generalForm.value.description,
        "matter_type": this.generalForm.value.matterType,
        "priority": this.generalForm.value.priority,
        "status": this.generalForm.value.status,
        "affidavit_isfiled": "na",
        "affidavit_filing_date": "",
        "created_date": this.datePipe.transform(
          this.generalForm.value.created_date,
          'dd-MM-yyyy'
        ),
        //"clients": this.editeMatterInfo?.clients.map((obj: any) => ({ "id": obj.id, "type": obj.type })),
        "clients": [
          ...(this.editeMatterInfo?.clients?.map((obj: any) => ({ "id": obj.id, "type": obj.type })) || []),
          ...(Array.isArray(this.editeMatterInfo?.corporate) ?
            this.editeMatterInfo.corporate.map((obj: any) => ({ "id": obj.id, "type": obj.type }))
            : [])
        ],
        "tags": this.tags?.length > 0 ? this.convertTagsToObject(this.tags) : {},
        //"group_acls": this.editeMatterInfo.groupAcls,
        //"members": this.editeMatterInfo?.members.map((obj: any) => ({ "id": obj.id })),
        "members": this.editeMatterInfo?.members.map((obj: any) => ({ "id": obj.id })).filter((member: any, index: any, self: any[]) => index === self.findIndex((m) => m.id === member.id)),
        "documents": this.Documents?.map((obj: any) => ({
          "docid": obj.docid,
          "doctype": obj.doctype,
          "user_id": obj.user_id
        }))
      }
      //console.log('data',data)

      this.spinnerService.show();
      this.httpService.sendPostRequest(URLUtils.checkMatterUnique, editbody).subscribe((res: any) => {
      this.spinnerService.hide();
        if (res.error) {
          this.confirmationDialogService.confirm('Alert', res.msg, false, 'OK', 'Cancel', true)
            .then((confirmed) => {
              if (confirmed) {
              }
            })
          return;
        }
        else {
          this.httpService.sendPatchRequest(URLUtils.updateGeneralMatter(this.matterId || this.editeMatterInfo.id), data).subscribe((res: any) => {
            this.spinnerService.hide();
            if (!res.error) {
              // this.confirmationDialogService.confirm('Success', 'Congratulations! You have successfully updated the matter information.', false, 'View Matter List', '', true, 'sm', true, true)
              //   .then((confirmed) => {
              //     if (confirmed) {
              //       this.router.navigate(['/matter/generalmatter/view']);
              //     }
              //   })
              this.toast.success("Matter Info updated successfully");
              //console.log('emitting edit event')
                 this.childButtonEvent.emit({
                  ...this.generalForm.value,
                  matter_id: this.matterId ?? this.editeMatterInfo?.id,
                  isEdit: true
                });
            }
            else {
              this.toast.error(res.msg)
            }
          }, (error: HttpErrorResponse) => {
            this.spinnerService.hide();
            if (error.status === 401 || error.status === 403) {
              const errorMessage = error.error.msg || 'Unauthorized';
              this.toast.error(errorMessage);
            }
          })
        }
      })
    }
    else {
      let data = {
        "title": this.generalForm.value.title,
        "matter_number": this.generalForm.value.matterNumber,
        "startdate": this.pipe.transform(this.generalForm.value.startdate, 'dd-MM-yyyy'),
        "closedate": this.pipe.transform(this.generalForm.value.closedate, 'dd-MM-yyyy'),
        "description": this.generalForm.value.description,
        "matter_type": this.generalForm.value.matterType,
        "priority": this.generalForm.value.priority,
        "status": this.generalForm.value.status,
        "affidavit_isfiled": "na",
        "affidavit_filing_date": "",
        "created_date": this.datePipe.transform(
          this.generalForm.value.created_date,
          'dd-MM-yyyy'
        ),
        //"clients": this.editeMatterInfo?.clients.map((obj: any) => ({ "id": obj.id, "type": obj.type })),
        "clients": [
          ...(this.editeMatterInfo?.clients?.map((obj: any) => ({ "id": obj.id, "type": obj.type })) || []),
          ...(Array.isArray(this.editeMatterInfo?.corporate) ?
            this.editeMatterInfo.corporate.map((obj: any) => ({ "id": obj.id, "type": obj.type }))
            : [])
        ],
        "tags": this.tags?.length > 0 ? this.convertTagsToObject(this.tags) : {},
        //"group_acls": this.editeMatterInfo.groupAcls,
        //"members": this.editeMatterInfo?.members.map((obj: any) => ({ "id": obj.id })),
        "members": this.editeMatterInfo?.members.map((obj: any) => ({ "id": obj.id })).filter((member: any, index: any, self: any[]) => index === self.findIndex((m) => m.id === member.id)),
        "documents": this.Documents?.map((obj: any) => ({
          "docid": obj.docid,
          "doctype": obj.doctype,
          "user_id": obj.user_id
        }))
      }
      //console.log('data',data)

      this.httpService.sendPatchRequest(URLUtils.updateGeneralMatter(this.matterId || this.editeMatterInfo.id), data).subscribe((res: any) => {
        if (!res.error) {
          //this.toast.success("Matter Info updated successfully");
          this.childButtonEvent.emit(this.generalForm.value);
        }
        else {
          this.toast.error(res.msg)
        }
      }, (error: HttpErrorResponse) => {
        if (error.status === 401 || error.status === 403) {
          const errorMessage = error.error.msg || 'Unauthorized';
          this.toast.error(errorMessage);
        }
      })
    }
}


  addEvent(type: string, event: any) {
    //  this.events.push(`${type}: ${event.value}`);
    //console.log("Date --->" + this.events);
  }
  addEventStart(type: string, event: any) {
    this.minDateEnd = event.value;
    //console.log(event.value);
  }
    
  OnCancel() {
    let caseReg = this.generalForm.value
    localStorage.setItem('oncancel', "oncancel");

    const hasValidInput =
      (this.generalForm.get('title')?.touched && caseReg.title?.trim().length > 0) ||
      (this.generalForm.get('description')?.touched && caseReg.case_number?.trim().length > 0) ||
      (this.generalForm.get('startdate')?.touched && caseReg.case_type?.trim().length > 0) ||
      (this.generalForm.get('closedate')?.touched && caseReg.court_name?.trim().length > 0) ||
      (this.generalForm.get('matterNumber')?.touched && caseReg.date_of_filling?.trim().length > 0) ||
      (this.generalForm.get('matterType')?.touched && caseReg.description?.trim().length > 0) ||
      (this.generalForm.get('priority')?.touched && caseReg.priority?.trim().length > 0) ||
      (this.generalForm.get('status')?.touched && caseReg.status?.trim().length > 0);

    // console.log('data', this.data)
    // console.log('hasValidInput', hasValidInput)
    // if (this.isEdit) {
    //   this.router.navigate(['/matter/generalmatter/view']);
    // }
    // else {
      if (hasValidInput) {
        // this.onSubmit();
        this.dialog.open(GeneralleavepageComponent, {
          width: '350px',  // Set the width here
          height: '180px',
          hasBackdrop: true,
          panelClass: 'hello',
          disableClose: true
        });
        return;
      }
      else {
        this.router.navigate(['/matter/generalmatter/view']);
      }
    // }
  }


    getGeneralMatters() {
    this.spinnerService.show();
    let page = { paginate: true };

    this.httpService.sendGetRequest(URLUtils.getGeneralMatter,page).subscribe((res: any) => {
      // this.spinnerService.hide();
      // this.generalMatters = res && res["matters"];
      // this.relNextCursor = res?.next_cursor;
      // this.relPrevCursor = res?.prev_cursor;
      // if (res && res["matters"]) {
      //   this.generalMatters = res["matters"].map((matter: any) => {
      //     const uniqueMembers = new Map(); // Remove duplicate members
      //     matter.members.forEach((member: any) => {
      //       if (!uniqueMembers.has(member.id)) {
      //         uniqueMembers.set(member.id, member);
      //       }
      //     });
      //     matter.members = Array.from(uniqueMembers.values());
          
      //     matter.groups = matter.groups.filter((group: any) => 
      //       group.name !== 'AAM' && group.name !== 'SuperUser'
      //     );
      //     return matter;
      //   });
      //   //console.log('Filtered generalMatters:', this.generalMatters);
      // }
      //this.matterCount = this.generalMatters.length;
      //console.log('this.generalMatters',this.generalMatters.length)
    })
  }

  OnSaveLater() {
    let caseReg = this.generalForm.value
    localStorage.setItem('oncancel', "oncancel");

    const hasValidInput =
      (this.generalForm.get('title')?.touched && caseReg.title?.trim().length > 0) ||
      (this.generalForm.get('description')?.touched && caseReg.case_number?.trim().length > 0) ||
      (this.generalForm.get('startdate')?.touched && caseReg.case_type?.trim().length > 0) ||
      (this.generalForm.get('closedate')?.touched && caseReg.court_name?.trim().length > 0) ||
      (this.generalForm.get('matterNumber')?.touched && caseReg.date_of_filling?.trim().length > 0) ||
      (this.generalForm.get('matterType')?.touched && caseReg.description?.trim().length > 0) ||
      (this.generalForm.get('priority')?.touched && caseReg.priority?.trim().length > 0) ||
      (this.generalForm.get('status')?.touched && caseReg.status?.trim().length > 0);

    if (this.isEdit) {
      this.onSubmit();
      this.spinnerService.show();
      setTimeout(() => {
        this.spinnerService.hide();
        this.getGeneralMatters();

        this.router.navigate(
          ['/matter/generalmatter/view'],
          {
            state: {
              refresh: true
            }
          }
        );
      }, 1000);
      return;
    }
    else {
      if (hasValidInput || this.data) {
        this.onSubmit();
        // this.dialog.open(GeneralleavepageComponent, {
        //   width: '350px',  // Set the width here
        //   height: '180px',
        //   hasBackdrop: true,
        //   panelClass: 'hello',
        //   disableClose: true
        // });
      }
      else {
        this.router.navigate(['/matter/generalmatter/view']);
      }
    }
    // else {
    //   //this.generalForm.reset();
    //   this.generalForm.patchValue({
    //     title: '',
    //     matterNumber: '',
    //     startdate: '',
    //     closedate: '',
    //     description: '',
    //     matterType: '',
    //     status: ['Active'],
    //     priority: ['High']
    //   });
    // }
  }
  getDocuments() {
    this.httpService.sendGetRequest(URLUtils.generalHistoryDocuments(this.editeMatterInfo.id)).subscribe(
      (res: any) => {
        if (res) {
          this.Documents = res.documents;
        }
      });
  }
  restricttextSpace(event: any) {
    let inputValue: string = event.target.value;
    inputValue = inputValue.replace(/^\s+/, '');
    inputValue = inputValue.replace(/\s{2,}/g, ' ');
    event.target.value = inputValue;
    return;
  }
}
